import BaseApiAction from '@Actions/base-api-action';

export default class UpdateClub extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'clubs-updateClub',
      payload: {
        doc_id: this._payload.doc_id,
        name: this._payload.name,
        short_name: this._payload.short_name,
        represents: this._payload.represents,
        admins: this._payload.admins,
      },
    });
  }

  onSuccess(data) {
    this._state.admin.clubs.events.clubUpdated.emit();
    super.onSuccess(data);
  }
}
